<script setup>
import { ref } from "vue";
import { formatearInputMoneda } from "@/utils/helpers";
import { verLote, verLotesSubasta } from "@/utils/subastaRedirections";

defineProps({
  garantiasStore: Object,
});

const show = ref(false);
const toggle = () => (show.value = !show.value);
</script>

<template>
  <div class="mt-3">
    <button
      class="btn w-100 d-flex justify-content-between align-items-center btn-ofertas-vigentes"
      type="button"
      @click="toggle"
    >
      <span class="fw-bold">Ofertas vigentes</span>
      <i :class="show ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
    </button>

    <div v-if="show" class="card border-0 shadow-sm mt-2">
      <div class="card-body p-0">
        <div
          v-if="!garantiasStore.resumen.ofertas_realizadas || garantiasStore.resumen.ofertas_realizadas.length === 0"
          class="py-4 text-center text-muted"
        >
          <i class="fa-regular fa-circle-xmark d-block fs-3 mb-2"></i>
          No hay ofertas vigentes
        </div>

        <div
          v-for="puja in garantiasStore.resumen.ofertas_realizadas"
          :key="puja.id"
          class="d-flex justify-content-between align-items-center px-4 py-1 border-bottom hover-row"
        >
          <div class="me-2">
            <div class="small text-muted">Subasta ID {{ puja?.subasta?.external_id }}</div>
            <h6
              class="mb-1 fw-semibold text-dark cursor-pointer"
              @click="verLotesSubasta(puja?.subasta?.id)"
            >
              {{ puja?.subasta?.titulo }}
            </h6>
            <p
              class="mb-0 text-secondary small cursor-pointer"
              @click="verLote(puja?.lote?.id)"
            >
              Lote Nº{{ puja?.lote?.codintlote }} — {{ puja?.lote?.titulo }}
            </p>
          </div>
          <div class="text-end">
            <span class="badge bg-soft-green text-dark text-sm fs-6 px-2 py-1">
              $ {{ formatearInputMoneda(puja?.oferta_actual) }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.cursor-pointer { cursor: pointer; }
.hover-row:hover { background-color: #f8f9fa; transition: background-color 0.2s; }
.bg-soft-green { background-color: #e6f8ef; }

.btn-ofertas-vigentes {
  border-radius: 6px;
  border: 2px solid var(--Color, #006c4c) !important;
  background: #fff;
  color: #006C4C;
}
</style>
